module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP1"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("The difference between a fairy tale and a truck driver’s story is that the fairy tale starts with “Once upon a time,” whereas the truck driver’s story starts, “You ain’t gonna believe this…”")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("—AN OLD TRUCKER SAYING")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0